import styled from '@emotion/styled';
import { colorToAlpha } from 'helpers/insight';

export const SectionInformBlock = styled.div<{ ppa: number, priceTo: number; }>`
  ${({ theme, ppa, priceTo }) => `
    border-radius: ${theme.borderRadius.small};
    padding: 12px 16px;
    background-color: ${colorToAlpha(theme.colors.brand.main, 0.05)};
    display: flex;
    margin: 24px 0 0;
    > div {
      white-space: normal;
      max-width: 190px;
      color: ${theme.colors.brand.main};
      margin-right: 16px;
    }
    > svg path {
      fill: ${theme.colors.brand.main};
    }
    &:before {
      content: '';
      position: relative;
      bottom: 50px;
      height: 24px;
      right: ${100 - (Math.round(ppa / 1000) * 1000) / priceTo * 100}%;
      border: dashed 1px ${theme.colors.brand.main};
    }
  `}
`;

export const AccentedInformBlock = styled.div`
  ${({ theme }) => `
    border-radius: ${theme.borderRadius.large};
    padding: ${theme.spacing(1.5)} ${theme.spacing(2)};
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1.5)};
    margin-top: ${theme.spacing(2)};
    background-color: ${theme.colors.brand.lightPurple};
    > span {
      border-radius: ${theme.borderRadius.round};
      height: 40px;
      width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: ${theme.colors.brand.purple};
      flex-shrink: 0;
    }
  `}
`;

